<template>
    <div>
        <div class="row">
            <spinner v-if="loading.templates"></spinner>
            <form v-else data-vv-scope="email-template">
                <div class="col-md-5">
                    <div class="form-group" :class="{ 'has-error': errors.has('email-template.email-template-name') }">
                        <label for="email-template-name">* Template name</label>
                        <input type="text"
                               class="form-control"
                               id="email-template-name"
                               v-model="template.name"
                               placeholder="Template Name"
                               name="email-template-name"
                               v-validate="'required'"
                               data-vv-as="Template Name"
                        />
                        <span v-show="errors.has('email-template.email-template-name')"
                              class="help-block">{{ errors.first('email-template.email-template-name') }}</span>
                    </div>
                    <div class="form-group" :class="{ 'has-error': errors.has('email-template.email-template-subject') }">
                        <label for="email-template-body">* Subject</label>
                        <textarea class="form-control"
                                  rows="2"
                                  v-model="template.subject"
                                  placeholder="Subject"
                                  name="email-template-subject"
                                  v-validate="'required'"
                                  data-vv-as="Subject"></textarea>
                        <span v-show="errors.has('email-template.email-template-subject')"
                              class="help-block">{{ errors.first('email-template.email-template-subject') }}</span>
                    </div>
                    <div class="form-group" :class="{ 'has-error': errors.has('email-template.email-template-header') }">
                        <label for="email-template-header">* Header Banner</label>
                        <input type="text"
                               class="form-control"
                               id="email-template-header"
                               v-model="template.header"
                               placeholder="Header (Banner)"
                               name="email-template-header"
                               v-validate="'required'"
                               data-vv-as="Header (Banner)"
                        />
                        <span v-show="errors.has('email-template.email-template-header')"
                              class="help-block ">{{ errors.first('email-template.email-template-header') }}</span>
                    </div>
                    <div class="form-group" :class="{ 'has-error': errors.has('email-template.email-template-sincerely') }">
                        <label for="email-template-sender">* Sincerely,</label>
                        <select class="form-control"
                                id="email-template-sender"
                                v-model="template.sender"
                                name="email-template-sincerely"
                                v-validate="'required'"
                                data-vv-as="Sincerely">
                            <option :value="null" disabled selected>Select option...</option>
                            <option v-for="sender, senderKey in newEmailOptions.senders" :value="senderKey">{{sender.name}} <{{sender.email}}></option>
                        </select>
                        <span v-show="errors.has('email-template.email-template-sincerely')"
                              class="help-block">{{ errors.first('email-template.email-template-sincerely') }}</span>
                    </div>

                    <button class="btn green" @click.prevent="saveTemplate(false)">Save</button>
                    <button class="btn green" @click.prevent="saveTemplate(true)">Save and Send Email</button>
                    <button class="btn default" @click.prevent="$emit('back')">Back</button>

                </div>
                <div class="col-md-7">
                    <div class="form-group" :class="{ 'has-error': errors.has('email-template.email-template-body') }">
                        <label for="email-template-body">* Body</label>
                        <textarea class="form-control"
                                  rows="20"
                                  id="email-template-body"
                                  v-model="template.body"
                                  placeholder="Body"
                                  name="email-template-body"
                                  v-validate="'required'"
                                  data-vv-as="Body"></textarea>
                        <span v-show="errors.has('email-template.email-template-body')"
                              class="help-block">{{ errors.first('email-template.email-template-body') }}</span>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from "vuex";
    import Spinner from "@/components/Spinner";
    import vSelect from 'vue-select';

    export default {

        components: {
            Spinner,
            VueSelect: vSelect
        },
        props: ['templateId'],

        computed: {
            ...mapGetters({
                appUser: 'getUser',
                newEmailOptions: 'emails/getNewEmailOptions',
                lastCreatedTemplate: 'emails/getLastCreatedTemplate',
                loading: 'emails/getLoading',
                template: 'emails/getTemplate',
                email: 'emails/getEmail'
            }),
        },

        mounted() {
            if (this.templateId) {
                this.fetchTemplate(this.templateId);
            } else {
                this.$validator.reset();
                this.resetTemplate();
            }
            this.fetchNewEmailOptions();
        },

        methods: {
            ...mapActions('emails',[
                'fetchNewEmailOptions',
                'fetchTemplate',
                'createTemplate',
                'updateTemplate',
                'resetEmail',
                'resetTemplate'
            ]),
            saveTemplate(send) {

                this.$validator.validateAll('email-template').then((result) => {
                    if (result) {
                        if(this.template.id) {
                            this.updateTemplate({
                                'template' : this.template
                            }).then((response) => {
                                if(response.data.status == 'success') {
                                    this.$notify('Template updated!');
                                    if (send) {
                                        this.resetEmail();
                                        this.email.template_id = this.lastCreatedTemplate.id;
                                        this.$router.push({name: 'Email Settings', hash: '#new-email'});
                                    }
                                } else {
                                    this.$notify({type: 'error', text: 'Something went wrong while updating template.'});
                                }
                            });
                            return;
                        }

                        this.createTemplate({
                            'template': this.template
                        }).then((response) => {
                            if (response.data.status == 'success') {
                                this.$notify('Template created!');
                                if (send) {
                                    this.resetEmail();
                                    this.email.template_id = this.lastCreatedTemplate.id;
                                    this.$router.push({name: 'Email Settings', hash: '#new-email'});
                                }
                            } else {
                                this.$notify({type: 'error', text: 'Something went wrong while creating template.'});
                            }
                        });
                    }
                });
            }
        },

        inject: {
            $validator: '$validator'
        },
    }
</script>



// WEBPACK FOOTER //
// EditTemplate.vue?09e86b08